(() => {
  function initializePasswordAccess() {
    const trigger = document.querySelector('[data-password-access-open]');
    const dialog = document.querySelector('[data-password-access-dialog]');
    if (!(trigger instanceof HTMLElement) || !(dialog instanceof HTMLDialogElement)) return;

    const closeButton = dialog.querySelector('[data-password-access-close]');
    const openDialog = () => {
      if (!dialog.open) dialog.showModal();
      window.setTimeout(() => dialog.querySelector('input[name="password"]')?.focus(), 0);
    };

    trigger.addEventListener('click', openDialog);
    closeButton?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => trigger.focus());

    if (dialog.querySelector('[data-password-access-error]')) openDialog();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePasswordAccess);
  } else {
    initializePasswordAccess();
  }
})();
